var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClaimRowPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4 4h12c.5522847 0 1 .44771525 1 1v14c0 .5522847-.4477153 1-1 1h-12c-.55228475 0-1-.4477153-1-1v-14c0-.55228475.44771525-1 1-1zm1 3v1h5v-1zm0 5v1h10v-1zm0 2v1h9v-1zm0 2v1h5v-1z",
    fill: "#dee2e6",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimRowPending);
export default __webpack_public_path__ + "static/media/claim-row-pending.76a415cc8a1ea0e1bb755a647e382cbd.svg";
export { ForwardRef as ReactComponent };